import React from 'react'
import { useLocation } from 'react-router-dom';
import './ProfileIDFeedBack.css'



const ProfileIDFeedBack = () => {
    const location = useLocation()
    const eventsWithSameProfile = location.state?.profile
    console.log('data from feedback :', eventsWithSameProfile);

    return (
        <div>
            <div className="profileid-information-container">
                <div className="profileid-container">
                    <div className="profileid-content-container">
                        <h5 className="profileid-side-top-heading">Profile ID</h5>
                        <p className="profileid-content">{eventsWithSameProfile[0]?.feedback_user_id?.profile_id}</p>
                    </div>
                    <div className="profileid-content-container">
                        <h5 className="profileid-side-top-heading">User Status</h5>
                        <p className="profileid-content"  >
                            {eventsWithSameProfile[0]?.feedback_user_id?.user_type === "user" ? "Traveller" : "Organiser"}
                        </p>
                    </div>

                    <div className="profileid-content-container">
                        <h5 className="profileid-side-top-heading">Full Name</h5>
                        <p className="profileid-content">
                            {eventsWithSameProfile[0]?.feedback_user_id?.firstName} {eventsWithSameProfile[0]?.feedback_user_id?.lastName}
                        </p>
                    </div>

                    {eventsWithSameProfile[0]?.feedback_user_id?.user_type === "organiser" ?
                        (
                            <div className="profileid-content-container">
                                <h5 className="profileid-side-top-heading">Overall organiser rating</h5>
                                <p className="profileid-content"  >
                                    {eventsWithSameProfile[0]?.feedback_user_id?.user_type === "user" ? "Traveller" : "Organiser"}
                                </p>
                            </div>
                        ) :
                        (<div></div>)}
                </div>
            </div>
            <br></br>
            <p className="upcomingsession-text">Total Reviews({eventsWithSameProfile.length})</p>
            {eventsWithSameProfile.map((eachEvent, index) => (
                <div key={index} className="profileid-container">
                    <div className="profileid-content-container">
                        <h5 className="profileid-side-no">{index + 1}</h5>
                        <h5 className="profileid-side-heading">Event ID</h5>
                        <p className="profileid-content1">{eachEvent?.feedback_event_id?.ID_event} </p>
                    </div>
                    <div className="profileid-content-container">
                        <h5 className="profileid-side-heading">Event title</h5>
                        <p className="profileid-content">{eachEvent?.feedback_event_id?.trip_title} </p>
                    </div>
                    <div className="profileid-content-container">
                        <h5 className="profileid-side-heading">Event date</h5>
                        <p className="profileid-content1">{eachEvent?.feedback_event_id?.start_date} </p>
                    </div>
                    <div className="profileid-content-container">
                        <h5 className="profileid-side-heading">Overall event rating</h5>
                        <p className="profileid-content">
                            {/* {averageTripRating} */}
                            {eachEvent?.event_rating}
                        </p>
                    </div>
                    <div className="profileid-content-container">
                        <h5 className="profileid-side-heading">Organiser rating</h5>
                        <p className="profileid-content">
                            {eachEvent?.organiser_rating}
                        </p>
                    </div>
                    <div className="profileid-content-container">
                        <h5 className="profileid-side-heading">Mosted Enjoyed</h5>
                        <p className="profileid-content">
                            {eachEvent?.event_review.join(",  ") || 'Null'}
                        </p>
                    </div>
                    <div className="profileid-content-container">
                        <h5 className="profileid-side-heading">Areas to improve</h5>
                        <p className="profileid-content">{eachEvent?.mbt_experience?.join(",  ") || 'Null'}</p>
                    </div>
                    <div className="profileid-content-container">
                        <h5 className="profileid-side-heading">Organiser review</h5>
                        <p className="profileid-content">
                            {eachEvent?.organiser_review.join(" ") || 'Null'}
                        </p>
                    </div>
                    <div className="profileid-content-container">
                        <h5 className="profileid-side-heading">Suggestions</h5>
                        <p className="profileid-content">
                            {eachEvent?.suggestions || 'Null'}
                        </p>
                    </div>
                    <div className="profileid-content-container">
                        <h5 className="profileid-side-heading">Join more trips </h5>
                        <p className="profileid-content"> {eachEvent?.join_more_trips || 'Null'}</p>
                    </div>
                </div>
            ))}
            <br></br>
        </div>
    )
}

export default ProfileIDFeedBack;
